<template>
  <div class="stories-wrap" v-show="tabs == 'post'">
    <div v-for="(story, index) in stories_list" :key="story.story_id" class="stories-item" @click="detail(index)" >
      <img v-if="story.media_type == 1" :src="s3BaseUrl + '/stories/' + story.story_id + '.jpg'" alt="" />
      <video v-if="story.media_type == 2" :src="s3BaseUrl + '/stories/' + story.story_id + '.mp4'" autoplay muted loop alt=""></video>
      <div class="mask">
        <div v-show="story.link_stickers">
          <a v-for="link_sticker in story.link_stickers" :key="link_sticker.id" style="margin-right:10px" class="story-link pointer" :href="link_sticker.story_link.url" target="_blank">
            <font-awesome-icon :icon="['fas', 'link']" style="margin-right: 3px;" />
            {{ link_sticker.story_link.display_url }}
          </a>
        </div>
        <div v-show="story.mentiontag">
          <span v-for="mentiontag in story.mentiontag" :key="mentiontag.id" style="margin-right:10px">
            {{ "@" + mentiontag.user.username }}
          </span>
        </div>
        <div v-show="story.bloks_stickers">
          <span v-for="bloks_stickers in story.bloks_stickers" :key="bloks_stickers.id" style="margin-right:10px">
            {{ "@" + bloks_stickers.bloks_sticker.sticker_data.ig_mention.username }}
          </span>
        </div>
        <div v-show="story.hashtag">
          <span v-for="hashtag in story.hashtag" :key="hashtag.id" style="margin-right:10px">
            {{ "#" + hashtag.hashtag.name }}
          </span>
        </div>
        <div v-show="story.location">
          <span v-for="location in story.location" :key="location.id" style="margin-right:10px">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="margin-right: 3px;" />
            {{ location.location.name }}
          </span>
        </div>
        <div>{{ story.created_at }}</div>
      </div>
    </div>
    <div class="no-media-message" v-if="no_media_message_stories">
      <img src="../../assets/post_image.png" style="opacity:0.5" alt />
      <div class="no-media-message-description">{{ no_media_message_stories }}</div>
    </div>
  </div>
</template>

<script>
// const root = process.env.VUE_APP_API;
// const showStoriesAPI = root + "/api/search/show_stories";

export default {
  name: "storiesList",
  props: ["stories_list", "tabs", "no_media_message_stories"],
  components: {},
  data() {
    return {
      loading: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.showStories();
  },
  methods: {
    showStories() {
      this.$emit("showStories");
    },
    detail(index) {
      this.$emit("detail", index, 'stories');
    },
  },
  watch: {},
};
</script>
